import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import ColumnBox from 'components/ColumnBox';
import AddCircle from '@mui/icons-material/AddCircle';
import Restore from '@mui/icons-material/Restore';
import Person from '@mui/icons-material/Person';
import Beenhere from '@mui/icons-material/Beenhere';

import { useNavigate, createSearchParams } from 'react-router-dom';

import { apiHelper, baseUrl } from 'helpers/util'
import BigHeading from 'components/BigHeading';

export default function Form() {
    const [ aggregateData, setAggregateData ] = useState(null)
    const navigate = useNavigate();

    const loadResidencyData = function() {
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_custom_api`,
            "params": { "route": "folk_residency.residency_aggregate" } })
        .then(response => {
            if (response.status) {
                setAggregateData(response.json.message);
            }
            else { console.log(response.json); }
        })
    }
    const navigateToResidency = function(residencyName) {
        navigate({ "pathname": "/residency_dashboard/residency",
            "search": createSearchParams({
                'residency_name': residencyName
            }).toString() });
    }

    useEffect(function() {
        loadResidencyData();
    }, [])

    return (
        <>
        <div style={{ padding: '10px' }}>
            <span style={{ fontWeight: 'bold', fontSize: '17px' }}>
                Total beds: { aggregateData ? aggregateData.bed_info.total_beds : '' }
            </span><br/>
            <span style={{ fontWeight: 'bold', fontSize: '17px' }}>
                Filled beds: { aggregateData ? aggregateData.bed_info.occupied_beds : '' }
            </span><br/>
            <span style={{ fontWeight: 'bold', fontSize: '17px' }}>
                Vacant beds: { aggregateData ? aggregateData.bed_info.vacant_beds : '' }
            </span><br/>
            <span style={{ fontWeight: 'bold', fontSize: '17px' }}>
                OOS FOLK: { aggregateData ? aggregateData.bed_info.oos_boys : '' }
            </span><br/><br/>
        </div>

        { (aggregateData && aggregateData.residency_data && aggregateData.residency_data.length > 0) ?
        (<div style={{ "maxWidth": '800px', 'fontSize': '15px', padding: '10px' }}>
            { aggregateData.residency_data.map(r => 
                (<div key={r.residency_name} style={{ display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', backgroundColor: 'beige', margin: '5px 5px', padding: '5px', borderRadius: '5px',
                    cursor: 'pointer' }} onClick={() => navigateToResidency(r.residency_name)}>
                    <p style={{ "fontSize": '18px', fontWeight: 'bold' }}>{ r.residency_name }</p>
                    <div style={{ "display": 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                        <div style={{ "display": 'flex', justifyContent: 'space-between', width: '100%',
                            marginTop: '2.5px' }}>
                            <div style={{ "padding": '2.5px 10px', marginRight: '2.5px', marginLeft: '2.5px',
                                borderRadius: '10px', backgroundColor: 'grey', color: 'white' }}>
                                <span style={{ fontsize: '12px' }}>Total: { r.total_beds }</span>
                            </div>
                            <div style={{ "padding": '2.5px 10px', marginRight: '2.5px', marginLeft: '2.5px',
                                borderRadius: '10px', backgroundColor: 'red', color: 'white' }}>
                                <span style={{ fontsize: '12px' }}>Filled: { r.occupied_beds }</span>
                            </div>
                        </div>
                        <div style={{ "display": 'flex', justifyContent: 'space-between', width: '100%',
                                marginTop: '2.5px' }}>
                            <div style={{ "padding": '2.5px 10px', marginRight: '2.5px', marginLeft: '2.5px',
                                borderRadius: '10px', backgroundColor: 'green', color: 'white' }}>
                                <span style={{ fontsize: '12px' }}>Free: { r.vacant_beds }</span>
                            </div>
                            <div style={{ "padding": '2.5px 10px', marginRight: '2.5px', marginLeft: '2.5px',
                                borderRadius: '10px', backgroundColor: 'yellow', color: 'black' }}>
                                <span style={{ fontsize: '12px' }}>OOS: { r.oos_boys }</span>
                            </div>
                        </div>
                    </div>
                </div>)
            )}
        </div>)
        :
        <></>
        }
        </>
    );
}
